import * as React from 'react';

const s = require('./sale_item_block.css');

export const JKAdsBlock = () =>
  <div className="cg-col-18 cg-col-s-17 cg-col-xs-18">
    <div className={s['c-selfad-single-content']}>
      <h3 className={s['c-selfad-single-title']}>Добавьте свой ЖК</h3>
      <div className={s['c-selfad-single-description']}>
        Бесплатное размещение объявлений для застройщиков <br/>
        и их официальных представителей
      </div>
    </div>
  </div>;
